module.exports = __webpack_public_path__ + "static/media/document.47290b4b.svg";